import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NextPimField } from 'app/Model/Catalog/NextPimField';
import { ValidFeatureService } from 'app/Services/validFeature.service';
import { excelFieldNames, FieldNames, fieldNames } from 'app/Model/FieldNames';
import { ValueChangedEvent } from 'devextreme/ui/drop_down_box';
import { TemplateItem } from 'app/Model/Catalog/TemplateItem';
import { TemplateService } from 'app/Services/template.service';
import { comparePimFields, fillLastKey, isNextPimField, parsePimField } from 'app/Services/templateItemHelpers';
import { ValueChangedEvent as NumberBoxValueChangeEvent } from 'devextreme/ui/number_box';
import { TemplateItemTemplate } from '../../Model/Catalog/TemplateItemTemplate';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import { AiPromptsService } from '../../Services/aiprompt.service';
import { AiPrompt } from 'app/Model/aiprompt';
import { TemplateExcelComponent } from '../../catalog/functions/template/templateExcel.component';
import { ChangeDetectorRef } from '@angular/core';
import { DxDataGridComponent, DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { LoginService } from '../../Services/login.service';
import {TemplateFieldsService} from "../../Services/templateFields.service";

@Component({
    selector: 'np-advanced-template-kiprompts',
    templateUrl: './advanced-template-kiprompts.component.html',
    standalone: false
})
export class AdvancedTemplateKiPromptComponent implements OnInit {
  @Input() templateItem: TemplateItem;
  @Output() onUpdate = new EventEmitter<void>();

  validKIPrompts: AiPrompt[] = [];
  editedPrompt: AiPrompt = new AiPrompt();
  isPopupVisible = false;
  fieldList: TemplateItemTemplate[] = this.fieldService.supplierFields;

  get pimField() {
    if (!this.templateItem.pimFields || this.templateItem.pimFields.length === 0) {
      this.templateItem.pimFields = [new NextPimField()];
    }
    return this.templateItem.pimFields[0];
  }
  constructor(
    private templateService: TemplateService,
    private promptService: AiPromptsService,
    public loginService: LoginService,
    public fieldService: TemplateFieldsService
  ) {}

  async ngOnInit() {
    this.validKIPrompts = await this.promptService.getAll(this.loginService.currentCustomer.id);
    this.promptService.onChange.subscribe((x) => (this.validKIPrompts = x));
  }

  onEditingStart(e: DxDataGridTypes.EditingStartEvent<any, any>) {
    this.editedPrompt = e.data;
    this.editedPrompt ??= new AiPrompt('Neuer Prompt');
  }

  checkIfPromptSelected(): boolean {
    return this.pimField.systemKey && this.pimField.systemKey != '-1'
  }

  onSaveEdit = async () => {
    if (!this.editedPrompt) return;
    try {
      await this.promptService.update(this.editedPrompt, this.loginService.currentCustomer.id);
      let allPrompts = await this.promptService.getAll(this.loginService.currentCustomer.id);
      this.promptService.onChange.emit(allPrompts);
      this.isPopupVisible = false;
    } catch (err) {
      console.error(err);
    }
  };

  onCancelEdit = () => {
    this.isPopupVisible = false;
  };

  onSelectionChanged() {
    this.pimField.field = fieldNames.kIPromptsField;
    this.onUpdate.emit();
  }

  openPromptEditor() {
    this.isPopupVisible = true;
    this.editedPrompt = new AiPrompt();
  }

  openPromptEditorToEdit() {
    this.isPopupVisible = true;
    this.editedPrompt = this.validKIPrompts.find((x) => x.id == this.pimField.systemKey);
  }

  async deleteCurrentPrompt() {
    const id = this.pimField.systemKey;
    await this.promptService.delete(id, this.loginService.currentCustomer.id);

    const idx = this.validKIPrompts.findIndex((p) => p.id === id);
    if (idx >= 0) this.validKIPrompts.splice(idx, 1);
    this.pimField.systemKey = '-1';
  }
}
